import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';
import UploadCustomerOTAModalDisplay from './UploadCustomerOTAModalDisplay';
import { handleFileRead } from '../../Lib/FileHelpers';
import AssetService from '../../Services/AssetService';

export default class UploadCustomerOTAModal extends Component {
  static propTypes = {
    asset: PropTypes.shape({ _id: PropTypes.string }),
    toggleModal: PropTypes.func,
    handleCustomerOTAUpdated: PropTypes.func,
  };

  state = {
    error: '',
    file: undefined,
    fileDataBase64: undefined,
    otaType: { value: 'hfx_flash', label: 'HFX Flash' },
    uploadPending: false,
  };

  assetService = new AssetService();
  source = CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  handleFileSelect = ([file]) => {
    this.setState({ file }); // has properties: path, name, size and a few others

    const handleError = () => {
      this.setState({ error: 'error reading file' });
    };
    const handleSuccess = (fileDataBase64) => {
      this.setState({ fileDataBase64 });
    };
    handleFileRead(file, handleError, handleSuccess);
  };

  handleFileUpload = async () => {
    this.setState({ uploadPending: true });
    try {
      const {
        asset: { _id: assetID },
      } = this.props;

      await this.assetService.addAssetCustomerOTA(
        assetID,
        {
          file: this.state.fileDataBase64,
          filename: this.state.file.name,
          type: this.state.otaType.value,
        },
        this.source.token
      );

      this.setState({ uploadPending: false });
      await this.props.handleCustomerOTAUpdated();
      this.props.toggleModal();
    } catch (err) {
      if (!isCancel(err)) {
        this.setState({ uploadPending: true });
        this.setState({ error: err.response?.data?.message ?? err.message });
      }
    }
  };

  setOTAType = (otaType) => {
    this.setState({ otaType });
  };

  setError = (error) => {
    this.setState({ error });
  };

  render() {
    return (
      <UploadCustomerOTAModalDisplay
        {...this.props}
        {...this.state}
        handleFileSelect={this.handleFileSelect}
        handleFileUpload={this.handleFileUpload}
        setOTAType={this.setOTAType}
        setError={this.setError}
      />
    );
  }
}
